module.exports = __webpack_public_path__ + "img/about_layout4.f372c685.png";